var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-box"},[_c('div',{staticClass:"corner top-left"}),_c('div',{staticClass:"corner top-right"}),_c('div',{staticClass:"corner bottom-right"}),_c('div',{staticClass:"corner bottom-left"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }